import { NSARouterMakerResult } from "namirasoft-account-react";
import { SortItem } from "namirasoft-core";
import { GatewayGuardRailInputRow, GuardRailRow } from "namirasoft-inference";
import { NamirasoftMap } from "namirasoft-site-map";
import { IBaseComponentProps, NSBox, NSBoxEntity, NSRow } from "namirasoft-site-react";
import { Component, createRef } from "react";
import { InferenceRouterProps } from "../InferenceRouterProps";

export interface GatewayGuardRailLineProps extends IBaseComponentProps, NSARouterMakerResult, InferenceRouterProps
{
    index: number;
    deletable: boolean;
    onDelete: () => void;
    onChanged?: (value: GatewayGuardRailInputRow | null) => void;
}

export default class GatewayGuardRailLine extends Component<GatewayGuardRailLineProps>
{
    static IS_DIRTY(value: GatewayGuardRailInputRow | null): boolean
    {
        if (value && value.guard_rail_id)
            return true;
        return false;
    }

    private NSBoxEntity_GuardRailId = createRef<NSBoxEntity<GuardRailRow>>();

    constructor(props: GatewayGuardRailLineProps)
    {
        super(props);
        this.getValue = this.getValue.bind(this);
        this.isDirty = this.isDirty.bind(this);
        this.onChanged = this.onChanged.bind(this);
    }

    getValue(checkError: boolean = false): GatewayGuardRailInputRow | null
    {
        let guard_rail_id = this.NSBoxEntity_GuardRailId.current?.getValueOne(checkError) ?? "";
        if (!guard_rail_id)
            return null;
        return { guard_rail_id };
    }

    setValue(value: GatewayGuardRailInputRow)
    {
        this.NSBoxEntity_GuardRailId.current?.setValue(value.guard_rail_id);
    }

    isDirty(): boolean
    {
        return GatewayGuardRailLine.IS_DIRTY(this.getValue(false));
    }

    private onChanged()
    {
        if (this.props.onChanged)
            this.props.onChanged(this.getValue(false));
    }

    override render()
    {
        let namirasoft = new NamirasoftMap(this.props.account.token_manager, console.error);
        return (
            <NSRow style={{ ...this.props.style, flexWrap: "nowrap" }}>
                <NSBoxEntity<GuardRailRow>
                    ref={this.NSBoxEntity_GuardRailId}
                    {...this.props}
                    title={`Guard Rail ID ${this.props.index + 1}`}
                    required
                    multiple={false}
                    info={{ link: "https://namirasoft.com/inference/console-guide/gateway/#field-guard-rails" }}
                    table={namirasoft.inference.tables.guard_rail}
                    getValue={(item) => item.id}
                    getTitle={(item) => item.name}
                    getSort={() => new SortItem(namirasoft.inference.tables.guard_rail, namirasoft.inference.tables.guard_rail.columns.name, true)}
                    style={{ width: NSBox.width.double }}
                    onChanged={this.onChanged}
                    menu={{
                        builtin: { delete: { enabled: this.props.deletable, onDelete: () => { this.props.onDelete(); } } },
                        items: []
                    }}
                />
            </NSRow>
        );
    }
}